module.exports = __webpack_public_path__ + "img/marine_app_5.61b8cfb7.jpg";